<ng-container [ngSwitch]="filterConfigType">
  <mode-filter-values
    *ngSwitchCase="FilterConfigurationTypeEnum.IndividualValues"
    [field]="field"
    [filter]="currentFilter"
    [view]="view"
    [encoding]="encoding"
    [step]="step"
    [queryRunToken]="queryRunToken"
    (filterChange)="onFilterChange($event)"
    (stepChange)="onStepChange($event)"
    (isInvalid)="onIsInvalidChange($event)"
  ></mode-filter-values>
  <mode-filter-range-numeric
    *ngSwitchCase="FilterConfigurationTypeEnum.RangeNumeric"
    [field]="field"
    [filter]="currentFilter"
    [view]="view"
    [encoding]="encoding"
    [queryRunToken]="queryRunToken"
    (filterChange)="onFilterChange($event)"
    (isInvalid)="onIsInvalidChange($event)"
  ></mode-filter-range-numeric>
  <mode-relative-date-panel
    *ngSwitchCase="FilterConfigurationTypeEnum.RangeRelativeDate"
    [field]="field"
    [filter]="currentFilter"
    [view]="view"
    [encoding]="encoding"
    [queryRunToken]="queryRunToken"
    (filterChange)="onFilterChange($event)"
    (filterReplace)="onFilterReplace($event)"
    (isInvalid)="onIsInvalidChange($event)"
  ></mode-relative-date-panel>
</ng-container>
<div class="action-buttons">
  <div class="left-actions">
    <capra-button
      data-test="filter-modal-cancel-button"
      text="Cancel"
      variant="secondary"
      color="neutral"
      (clicked)="doCancel()"
    ></capra-button>
    <capra-button
      data-test="filter-modal-reset-button"
      text="Reset"
      variant="secondary"
      color="neutral"
      (clicked)="doReset()"
      [disabled]="!hasChanges"
    ></capra-button>
  </div>
  <div class="right-actions">
    <capra-button
      data-test="filter-modal-apply-button"
      text="Apply"
      variant="secondary"
      color="neutral"
      (clicked)="doApply(false)"
      [disabled]="!hasChanges || isInvalid"
    ></capra-button>
    <capra-button
      data-test="filter-modal-apply-and-close-button"
      text="Apply & close"
      color="default"
      (clicked)="doApply(true)"
      [disabled]="isInvalid"
    ></capra-button>
  </div>
</div>
